import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["id", "className", "rows", "actions", "hideActions", "isLoading", "hasError", "components", "options", "columns", "emptyViewProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import DataGrid from "../DataGrid";
import styles from "./styles";
import DateTimeFormatter from "./formatters/DateTimeFormatter";
import AttrFormatter from "./formatters/AttrFormatter";
import BoldFormatter from "./formatters/BoldFormatter";
import CarouselReadCell from "./formatters/CarouselReadCell";
const useStyles = createUseStyles(styles, 'SectionList');
function SectionList(_ref) {
  let {
      id,
      className,
      rows,
      actions,
      hideActions,
      isLoading,
      hasError,
      components,
      options,
      columns = [],
      emptyViewProps = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const rootClassName = classnames(classes.root, className);
  const vanillaComponents = useMemo(() => ({
    BoldFormatter
  }), []);

  // TODO Refactor to DataGrid vanilla components
  const gridComponents = useMemo(params => {
    return _objectSpread({
      DateTimeFormatter: _ref2 => {
        let {
          value
        } = _ref2;
        return /*#__PURE__*/React.createElement(DateTimeFormatter, {
          date: value
        });
      },
      AttrFormatter: props => /*#__PURE__*/React.createElement(AttrFormatter, props),
      CarouselReadCell
    }, components);
  }, [components]);
  return /*#__PURE__*/React.createElement(DataGrid, _extends({
    id: id,
    className: rootClassName,
    columnDefs: columns,
    rowData: rows,
    isLoading: isLoading,
    hasError: hasError,
    components: gridComponents,
    vanillaComponents: vanillaComponents,
    actions: actions,
    hideActions: hideActions,
    emptyViewProps: emptyViewProps
  }, options, props));
}
process.env.NODE_ENV !== "production" ? SectionList.propTypes = {
  id: PropTypes.string,
  rows: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.arrayOf(PropTypes.any),
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool
} : void 0;
export default /*#__PURE__*/React.memo(SectionList);